<div class="limit">
  <p class="limit-text">{{'POLL-CREATION.VOTERS.PLURINOMINAL' | translate}}</p>
  <textarea type="text" name="limit-voters-election" class="limit-voters" id="pluri-{{index}}"
  (focusout)="onVotersDone()" (keyup)="onVotersChanges($event)">{{numberOfVote}}</textarea>
</div>